module.exports = __webpack_public_path__ + "static/media/ExamSetCATAdd.e7446464.svg";